export const DEFAULT_INPUT_WIDTH = "18rem";
